import 'bootstrap-sass'

import 'collector-core/app/assets/javascripts/collector/core/core'
